import { type ReactNode, useEffect } from 'react';
import { HandHeartLineIcon, Slider } from 'ui';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: fix according to result of #67489
import { useIsChannelEmpty } from 'features/channels/hooks/useIsChannelEmpty';
import type { GivingsListFilter } from '../../types';
import { GivingCard } from '../giving-card';
import { useGivings } from './hooks';

type P = {
  colSpan?: 10 | 7;
  controls: {
    hasTitleIcon?: boolean;
    seeAll?: { limit?: number; onClick?: () => void };
    title: ReactNode;
    titleLevel?: 2 | 4;
  };
  description?: ReactNode;
  emptyState?: ReactNode;
  getPathToGivingDetail: (id: string) => string;
  onEmptyState?: (isEmpty: boolean) => void;
  query?: { filter?: GivingsListFilter };
};

const GivingsSlider = ({
  colSpan,
  controls: { hasTitleIcon, seeAll, title, titleLevel },
  description,
  emptyState,
  getPathToGivingDetail,
  onEmptyState,
  query,
}: P) => {
  const {
    query: { data, fetchNextPage, hasNextPage, isFetching, isLoading },
  } = useGivings({
    allowUnfeatured: Boolean(seeAll?.onClick),
    filter: query?.filter,
    pagination: {
      pageSize: 4,
    },
  });

  const givings = data?.pages.flatMap((givingsPaginated) => givingsPaginated.data);
  const givingsTotal = data?.pages[0]?.total ?? 0;

  const isEmpty = useIsChannelEmpty(isLoading, givings);

  // TODO this hack is needed together with useEffect in default channels to set empty state correctly
  useEffect(() => {
    onEmptyState?.(isEmpty);
  }, [isEmpty, onEmptyState]);

  return (
    <Slider
      colSpan={colSpan}
      controls={{
        seeAll: { limit: seeAll?.limit, onClick: seeAll?.onClick, total: givingsTotal },
        title,
        titleIcon: hasTitleIcon ? <HandHeartLineIcon /> : undefined,
        titleLevel,
      }}
      description={description}
      emptyState={emptyState}
      items={givings?.map((giving) => ({
        children: <GivingCard getPathToGivingDetail={getPathToGivingDetail} giving={giving} />,
        key: `giving-${giving.id}`,
      }))}
      queryData={{
        fetchNextPage,
        hasNextPage,
        isFetching,
        isLoading,
      }}
    />
  );
};

export default GivingsSlider;
